export default __webpack_public_path__ + "static/media/header-bg.e1954490.png";